import React, { useState, useRef, useEffect } from "react";
import useAxios from "../../hooks/useAxios";
import { message } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { ReactLoading } from "../Dashboard/TinManagement/import";

// Audio files for questions
const questionAudios = {
  // Listen and repeat questions
  "Leave town the next train.": {
    type: "listen_repeat",
    audio: "/audios/lr1.mp3",
  },
  "When it's cold, I don't go out.": {
    type: "listen_repeat",
    audio: "/audios/lr2.mp3",
  },
  "His car is being repaired.": {
    type: "listen_repeat",
    audio: "/audios/lr3.mp3",
  },
  "It's supposed to rain tomorrow, isn't it?": {
    type: "listen_repeat",
    audio: "/audios/lr4.mp3",
  },
  "Their loud talking irritated people nearby.": {
    type: "listen_repeat",
    audio: "/audios/lr5.mp3",
  },
  "Even though John is away, we can use his car.": {
    type: "listen_repeat",
    audio: "/audios/lr6.mp3",
  },
  "I'll call you as soon as I arrive.": {
    type: "listen_repeat",
    audio: "/audios/lr7.mp3",
  },
  "She has been working here since last year.": {
    type: "listen_repeat",
    audio: "/audios/lr8.mp3",
  },
  "The children are playing outside in the yard.": {
    type: "listen_repeat",
    audio: "/audios/lr9.mp3",
  },
  "He usually drinks coffee in the morning.": {
    type: "listen_repeat",
    audio: "/audios/lr10.mp3",
  },
  "He forgot to bring his wallet.": {
    type: "listen_repeat",
    audio: "/audios/lr11.mp3",
  },
  "Please turn off the light before you leave.": {
    type: "listen_repeat",
    audio: "/audios/lr12.mp3",
  },
  "The teacher gave us too much homework.": {
    type: "listen_repeat",
    audio: "/audios/lr13.mp3",
  },
  "She was very tired after the long journey.": {
    type: "listen_repeat",
    audio: "/audios/lr14.mp3",
  },
  "The store will close early today.": {
    type: "listen_repeat",
    audio: "/audios/lr15.mp3",
  },
  "I usually take the bus to work.": {
    type: "listen_repeat",
    audio: "/audios/lr16.mp3",
  },

  // Newly added Listen & Repeat (starting from lr17)
  "I spent so much time in the Bookshop that I missed the bus.": {
    type: "listen_repeat",
    audio: "/audios/lr17.mp3",
  },
  "I like to go for a walk every morning.": {
    type: "listen_repeat",
    audio: "/audios/lr18.mp3",
  },
  "Our grandparents house is located on the other side of town.": {
    type: "listen_repeat",
    audio: "/audios/lr19.mp3",
  },
  "Baby sitting would be provided by the older children.": {
    type: "listen_repeat",
    audio: "/audios/lr20.mp3",
  },
  "As for myself, I am looking for a more challenging position.": {
    type: "listen_repeat",
    audio: "/audios/lr21.mp3",
  },
  "Please look over the terms of the agreement by Friday.": {
    type: "listen_repeat",
    audio: "/audios/lr22.mp3",
  },
  "The dog climbed from the chair and ran out of the door.": {
    type: "listen_repeat",
    audio: "/audios/lr23.mp3",
  },
  "Closing time has come and gone, but customers continue to arrive.": {
    type: "listen_repeat",
    audio: "/audios/lr24.mp3",
  },
  "Isn't Rahul supposed to handle this?": {
    type: "listen_repeat",
    audio: "/audios/lr25.mp3",
  },
  "The new President touched on several controversial topics during the meeting.":
    { type: "listen_repeat", audio: "/audios/lr26.mp3" },
  "Can't you find any cake in the drawer?": {
    type: "listen_repeat",
    audio: "/audios/lr27.mp3",
  },
  "I don't really know , if to tell you the truth.": {
    type: "listen_repeat",
    audio: "/audios/lr28.mp3",
  },
  "The movie was better than the book.": {
    type: "listen_repeat",
    audio: "/audios/lr29.mp3",
  },
  "My mother teaches in a primary school.": {
    type: "listen_repeat",
    audio: "/audios/lr30.mp3",
  },
  "The students gathered in the hall for the morning assembly.": {
    type: "listen_repeat",
    audio: "/audios/lr31.mp3",
  },
  "I couldn’t find the keys even after searching the entire room.": {
    type: "listen_repeat",
    audio: "/audios/lr32.mp3",
  },

  // One word questions
  "Does the tree have fewer trunks or branches?": {
    type: "question",
    audio: "/audios/q1.mp3",
  },
  "Are Oranges and banana fruits or vegetables?": {
    type: "question",
    audio: "/audios/q2.mp3",
  },
  "How many wheels are there in a bicycle?": {
    type: "question",
    audio: "/audios/q3.mp3",
  },
  "What is frozen water called?": { type: "question", audio: "/audios/q4.mp3" },
  "Which is usually thinner a finger or a leg?": {
    type: "question",
    audio: "/audios/q5.mp3",
  },
  "Which is more like stone cement or rubber?": {
    type: "question",
    audio: "/audios/q6.mp3",
  },
  "Which is heavier: gold or silver?": {
    type: "question",
    audio: "/audios/q7.mp3",
  },
  "What's the adult form of a puppy?": {
    type: "question",
    audio: "/audios/q8.mp3",
  },
  "What day comes after Friday?": { type: "question", audio: "/audios/q9.mp3" },
  "What's the opposite of 'hot'?": {
    type: "question",
    audio: "/audios/q10.mp3",
  },
  "Which is faster: a car or a bicycle?": {
    type: "question",
    audio: "/audios/q11.mp3",
  },
  "How many months are in a year?": {
    type: "question",
    audio: "/audios/q12.mp3",
  },
  "What do we call the opposite of 'day'?": {
    type: "question",
    audio: "/audios/q13.mp3",
  },
  "Which is colder: ice or fire?": {
    type: "question",
    audio: "/audios/q14.mp3",
  },
  "What shape is a coin?": { type: "question", audio: "/audios/q15.mp3" },
  "What is the capital of India?": {
    type: "question",
    audio: "/audios/q16.mp3",
  },

  // Newly added One Word (starting from q17)
  "Would you get water from a bottle or a newspaper?": {
    type: "question",
    audio: "/audios/q17.mp3",
  },
  "In which season would you be most likely to see snow in the garden?": {
    type: "question",
    audio: "/audios/q18.mp3",
  },
  "To repair a torn page in a book, should Madhav use oil or tape?": {
    type: "question",
    audio: "/audios/q19.mp3",
  },
  "Do people usually leave through windows or through doors?": {
    type: "question",
    audio: "/audios/q20.mp3",
  },
  "If I make a mistake when I am writing, should I transfer it or erase it?": {
    type: "question",
    audio: "/audios/q21.mp3",
  },
  "Which tool is used to cut a pair of scissors or a hammer?": {
    type: "question",
    audio: "/audios/q22.mp3",
  },
  "Does a balloon get bigger or smaller if you release some air?": {
    type: "question",
    audio: "/audios/q23.mp3",
  },
  "Where do people go to withdraw cash? An ATM or a hair salon?": {
    type: "question",
    audio: "/audios/q24.mp3",
  },
  "Lila thinks her homework is tedious. Does she enjoy it or dislike it?": {
    type: "question",
    audio: "/audios/q25.mp3",
  },
  "Jatin's latest film has a complex plot. Is it easy to follow or challenging?":
    { type: "question", audio: "/audios/q26.mp3" },
  "What liquid normally flows out of a tap?": {
    type: "question",
    audio: "/audios/q27.mp3",
  },
  "If information is classified as confidential, would you share it openly or keep it private?":
    { type: "question", audio: "/audios/q28.mp3" },
  "Would Dave's roof leak more on a sunny day or on a rainy day?": {
    type: "question",
    audio: "/audios/q29.mp3",
  },
  "Is your father's brother your uncle or your nephew?": {
    type: "question",
    audio: "/audios/q30.mp3",
  },
  "What is a young cat called?": { type: "question", audio: "/audios/q31.mp3" },
  "Do you put your shirt or coat on first?": {
    type: "question",
    audio: "/audios/q32.mp3",
  },

  // Join the sentences
  "We didn't enjoy the movie.": {
    type: "join_sentences",
    audio: "/audios/j1.mp3",
  },
  "You left your books at home.": {
    type: "join_sentences",
    audio: "/audios/j2.mp3",
  },
  "Every visitor was expecting a nice gift.": {
    type: "join_sentences",
    audio: "/audios/j3.mp3",
  },
  "The bottom part has been slightly damaged.": {
    type: "join_sentences",
    audio: "/audios/j4.mp3",
  },
  "We wondered if the new piano would fit in here.": {
    type: "join_sentences",
    audio: "/audios/j5.mp3",
  },
  "Don't let me down this time.": {
    type: "join_sentences",
    audio: "/audios/j6.mp3",
  },
  "She goes for a walk every day.": {
    type: "join_sentences",
    audio: "/audios/j7.mp3",
  },
  "They went to the station in the morning.": {
    type: "join_sentences",
    audio: "/audios/j8.mp3",
  },

  // New Sentence Build (starting from j9)
  "Was reading/ My mother/her favourite magazine.": {
    type: "join_sentences",
    audio: "/audios/j9.mp3",
  },
  "Article/ Every/ Read.": { type: "join_sentences", audio: "/audios/j10.mp3" },
  "Away/ please put/ that.": {
    type: "join_sentences",
    audio: "/audios/j11.mp3",
  },
  "Tomorrow I will / with Mr. Sharma / have a talk.": {
    type: "join_sentences",
    audio: "/audios/j12.mp3",
  },
  "The dog / loudly / barked / at the stranger.": {
    type: "join_sentences",
    audio: "/audios/j13.mp3",
  },
  "Went / yesterday / we / to the park.": {
    type: "join_sentences",
    audio: "/audios/j14.mp3",
  },
  "Quickly / the boy / finished / his homework.": {
    type: "join_sentences",
    audio: "/audios/j15.mp3",
  },
  "In the morning / I / drink / a cup of tea.": {
    type: "join_sentences",
    audio: "/audios/j16.mp3",
  },
};

const AudioPlayer = ({
  src,
  onPlayed,
  onAudioPlay,
  onAudioEnd,
  hasPlayed: hasPlayedProp = false,
}) => {
  const audioRef = useRef(null);
  const [hasPlayed, setHasPlayed] = useState(hasPlayedProp);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    setHasPlayed(false);
    setIsPlaying(false);
  }, [src]);

  const handlePlay = () => {
    if (!hasPlayed) {
      document.querySelectorAll("audio").forEach((audio) => {
        if (audio !== audioRef.current) {
          audio.pause();
          audio.currentTime = 0;
        }
      });

      audioRef.current.play();
      setHasPlayed(true);
      setIsPlaying(true);
      if (onAudioPlay) onAudioPlay();
      if (onPlayed) onPlayed();
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (onAudioEnd) onAudioEnd();
  };

  return (
    <div className="audio-controls flex items-center gap-4">
      <button
        onClick={handlePlay}
        disabled={hasPlayed}
        className={`px-4 py-2 rounded-lg font-medium flex items-center gap-2 ${
          hasPlayed
            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
            : "bg-blue-600 text-white hover:bg-blue-700"
        } ${isPlaying ? "bg-blue-700" : ""}`}
      >
        {isPlaying ? "Playing..." : hasPlayed ? "Played" : "Play Question"}
      </button>
      <audio
        ref={audioRef}
        src={src}
        onEnded={handleEnded}
        style={{ display: "none" }}
      />
    </div>
  );
};

const SpeakingAssessment = ({ phoneNumber }) => {
  // State
  const [questions, setQuestions] = useState(() => {
    const sections = [
      {
        name: "listenRepeat",
        questions: [
          // Existing ones
          "Leave town the next train.",
          "When it's cold, I don't go out.",
           "His car is being repaired.",
           "It's supposed to rain tomorrow, isn't it?",
          "Their loud talking irritated people nearby.",
          "Even though John is away, we can use his car.",
          "I'll call you as soon as I arrive.",
          "She has been working here since last year.",
          "The children are playing outside in the yard.",
          "He usually drinks coffee in the morning.",
          "He forgot to bring his wallet.",
          "Please turn off the light before you leave.",
          "The teacher gave us too much homework.",
          "She was very tired after the long journey.",
          "The store will close early today.",
          "I usually take the bus to work.",

          // New Listen & Repeat
          "I spent so much time in the Bookshop that I missed the bus.",
          "I like to go for a walk every morning.",
          "Our grandparents house is located on the other side of town.",
          "Baby sitting would be provided by the older children.",
          "As for myself, I am looking for a more challenging position.",
          "Please look over the terms of the agreement by Friday.",
          "The dog climbed from the chair and ran out of the door.",
          "Closing time has come and gone, but customers continue to arrive.",
          "Isn't Rahul supposed to handle this?",
          "The new President touched on several controversial topics during the meeting.",
          "Can't you find any cake in the drawer?",
          "I don't really know , if to tell you the truth.",
          "The movie was better than the book.",
          "My mother teaches in a primary school.",
          "The students gathered in the hall for the morning assembly.",
          "I couldn’t find the keys even after searching the entire room.",
        ],
      },
      {
        name: "oneWord",
        questions: [
          // Existing ones
         "Does the tree have fewer trunks or branches?",
         "Are Oranges and banana fruits or vegetables?",
         "How many wheels are there in a bicycle?",
          "What is frozen water called?",
          "Which is usually thinner a finger or a leg?",
          "Which is more like stone cement or rubber?",
          "Which is heavier: gold or silver?",
          "What's the adult form of a puppy?",
          "What day comes after Friday?",
          "What's the opposite of 'hot'?",
          "Which is faster: a car or a bicycle?",
          "How many months are in a year?",
          "What do we call the opposite of 'day'?",
          "Which is colder: ice or fire?",
          "What shape is a coin?",
          "What is the capital of India?",
          // New One Word
          "Would you get water from a bottle or a newspaper?",
          "In which season would you be most likely to see snow in the garden?",
          "To repair a torn page in a book, should Madhav use oil or tape?",
          "Do people usually leave through windows or through doors?",
          "If I make a mistake when I am writing, should I transfer it or erase it?",
          "Which tool is used to cut a pair of scissors or a hammer?",
          "Does a balloon get bigger or smaller if you release some air?",
          "Where do people go to withdraw cash? An ATM or a hair salon?",
          "Lila thinks her homework is tedious. Does she enjoy it or dislike it?",
          "Jatin's latest film has a complex plot. Is it easy to follow or challenging?",
          "What liquid normally flows out of a tap?",
          "If information is classified as confidential, would you share it openly or keep it private?",
          "Would Dave's roof leak more on a sunny day or on a rainy day?",
          "Is your father's brother your uncle or your nephew?",
          "What is a young cat called?",
          "Do you put your shirt or coat on first?",
        ],
      },
      {
        name: "joinSentences",
        questions: [
          // Existing ones
          "We didn't enjoy the movie.",
          "You left your books at home.",
          "Every visitor was expecting a nice gift.",
          "The bottom part has been slightly damaged.",
          "We wondered if the new piano would fit in here.",
          "Don't let me down this time.",
          "She goes for a walk every day.",
          "They went to the station in the morning.",
          // New Sentence Build (Jumbled)
          "Was reading/ My mother/her favourite magazine.",
          "Article/ Every/ Read.",
          "Away/ please put/ that.",
          "Tomorrow I will / with Mr. Sharma / have a talk.",
          "The dog / loudly / barked / at the stranger.",
          "Went / yesterday / we / to the park.",
          "Quickly / the boy / finished / his homework.",
          "In the morning / I / drink / a cup of tea.",
          ],
      },
    ];

    const getRandomItems = (arr, count) => {
      const shuffled = [...arr].sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, count);
      return selected.sort((a, b) => arr.indexOf(a) - arr.indexOf(b));
    };

    const selectedQuestions = [];
    sections.forEach((section) => {
      const quarterLength = Math.ceil(section.questions.length * 0.25);
      selectedQuestions.push(...getRandomItems(section.questions, quarterLength));
    });

    return selectedQuestions;
  });

  const api = useAxios();
  const history = useHistory();
  const { phone } = useParams();

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [recordings, setRecordings] = useState({});
  const [recording, setRecording] = useState(false);
  const [currentRecording, setCurrentRecording] = useState(null);
  const [hasRecorded, setHasRecorded] = useState({});
  const [response, setResponse] = useState(null);
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [playedQuestions, setPlayedQuestions] = useState({});
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [showPopup, setShowPopup] = useState(true);
  const [currentSection, setCurrentSection] = useState(null);
  const [testSubmitted, setTestSubmitted] = useState(false);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const timerRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(60);

  // Section descriptions
  const sectionInfo = {
    listen_repeat: {
      title: "Listen and Repeat",
      description:
        "In this section, you will listen to a sentence and repeat it as accurately as possible. Focus on pronunciation and intonation.",
    },
    question: {
      title: "One Word Answers",
      description:
        "Listen to the question and provide the one-word answer. Ensure your response is clear and concise.",
    },
    join_sentences: {
      title: "Join the Sentences",
      description:
        "Listen to the jumbled sentence and repeat it in the correct order. Pay attention to grammar and structure.",
    },
  };

  const checkTest = async () => {
    try {
      setLoad(true);
      await api.post(`/languageConfidence/checkMobileNoExist`, {
        formId: "61d41ac7cc03506243d626f9",
        mobileNo: phone,
      });
    } catch (err) {
      console.error(err);
      message.error(
        err?.response?.data?.error?.message || `Something went wrong.`
      );
      setTimeout(() => {
        return history.push(`/language-confidence`);
      }, 2 * 1000);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    checkTest();
  }, [phone]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    const handlePageHide = () => {
      console.log("Page is closing (iOS fallback)");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);

  // Detect section change
  useEffect(() => {
    const questionData = questionAudios[questions[currentQuestion]];
    const sectionType = questionData ? questionData.type : null;

    if (sectionType && sectionType !== currentSection) {
      setCurrentSection(sectionType);
      setShowPopup(true);
    }
  }, [currentQuestion, questions, currentSection]);

  const startRecording = async () => {
    if (hasRecorded[currentQuestion]) return;

    setRecording(true);
    setTimeLeft(60);
    setCurrentRecording(null);
    audioChunksRef.current = [];

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm",
      });
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        setCurrentRecording(blob);
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };

      mediaRecorder.start();
    } catch (error) {
      console.error("Recording error:", error);
      setRecording(false);
      message.error("Could not access microphone. Please check permissions.");
    }
  };

  const stopRecording = () => {
    setRecording(false);
    setTimeLeft(60);
    setHasRecorded((prev) => ({
      ...prev,
      [currentQuestion]: true,
    }));
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream
        .getTracks()
        .forEach((track) => track.stop());
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const saveCurrentRecording = () => {
    if (currentRecording) {
      setRecordings((prev) => ({
        ...prev,
        [currentQuestion]: currentRecording,
      }));
    }
  };

  const goToNextQuestion = () => {
    saveCurrentRecording();
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      const reshuffled = [...questions].sort(() => 0.5 - Math.random());
      setQuestions(reshuffled);
      setHasRecorded({});
      setCurrentQuestion(0);
    }
    setCurrentRecording(null);
  };

  const handleSubmit = async () => {
    saveCurrentRecording();

    const allRecordings = {
      ...recordings,
      ...(currentRecording ? { [currentQuestion]: currentRecording } : {}),
    };

    if (Object.keys(allRecordings).length === 0) {
      message.error("Please record at least one answer before submitting.");
      return;
    }

    const formData = new FormData();
    Object.entries(allRecordings).forEach(([questionIndex, blob]) => {
      formData.append(
        `audio_${questionIndex}`,
        blob,
        `question_${questionIndex}.webm`
      );
    });

    formData.append("questions", JSON.stringify(questions));
    formData.append("phoneNumber", phone);
    formData.append("formId", "61d41ac7cc03506243d626f9");

    try {
      setLoading(true);
      const { data } = await api.post(
        `/languageConfidence/confidence`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const { success } = data || {};

      if (success) {
        setTestSubmitted(true);
        message.success("Test submitted successfully", 2);
        setTimeout(() => {
          return history.replace(`/careers`);
        }, 2 * 1000);
      }

      console.log(data);
      // setResponse(data);
    } catch (err) {
      console.error(err);
      message.error("Upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (recording && timeLeft > 0) {
      timerRef.current = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else if (recording && timeLeft === 0) {
      stopRecording();
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [recording, timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const isLastQuestion = currentQuestion === questions.length - 1;
  const hasRecordingForCurrentQuestion =
    recordings[currentQuestion] || currentRecording;

  const allQuestionsAnswered = questions.every((_, index) =>
    index === currentQuestion
      ? recordings[index] || currentRecording
      : recordings[index]
  );

  if (response) {
    return (
      <div className="p-6 max-w-4xl mx-auto mt-8 shadow-lg rounded-lg bg-white">
        <h2 className="text-3xl font-bold mb-6 text-center text-green-600">
          Assessment Complete!
        </h2>

        <div className="mb-8">
          <h3 className="text-2xl font-semibold mb-4">Your Scores</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-lg">
            <div className="bg-blue-50 p-4 rounded-lg text-center">
              <p className="font-medium text-blue-800">Pronunciation</p>
              <p className="text-2xl font-bold text-blue-600">
                {response?.data?.pronunciation?.overall_score || "N/A"}
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg text-center">
              <p className="font-medium text-green-800">Fluency</p>
              <p className="text-2xl font-bold text-green-600">
                {response?.data?.fluency?.overall_score || "N/A"}
              </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg text-center">
              <p className="font-medium text-purple-800">Vocabulary</p>
              <p className="text-2xl font-bold text-purple-600">
                {response?.data?.vocabulary?.overall_score || "N/A"}
              </p>
            </div>
            <div className="bg-orange-50 p-4 rounded-lg text-center">
              <p className="font-medium text-orange-800">Grammar</p>
              <p className="text-2xl font-bold text-orange-600">
                {response?.data?.grammar?.overall_score || "N/A"}
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg text-center md:col-span-2">
              <p className="font-medium text-red-800">Overall Score</p>
              <p className="text-3xl font-bold text-red-600">
                {response?.data?.overall?.overall_score || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {response?.data?.pronunciation?.english_proficiency_scores && (
          <div className="mb-8">
            <h3 className="text-2xl font-semibold mb-4">
              IELTS & PTE Equivalent Scores
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-lg">
              {Object.entries(
                response.data.pronunciation.english_proficiency_scores
              ).map(([testName, scoreObj]) => (
                <div
                  key={testName}
                  className="bg-yellow-50 p-4 rounded-lg text-center shadow-sm"
                >
                  <p className="font-medium text-yellow-800">
                    {testName.toUpperCase()}
                  </p>
                  <p className="text-2xl font-bold text-yellow-600">
                    {scoreObj.prediction}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="content-relevance-section">
          <h2>Content Relevance Results</h2>
          {response?.data?.content_relevance?.map((item, index) => (
            <div
              key={index}
              className="relevance-card"
              style={{
                border: "1px solid #ccc",
                padding: "15px",
                margin: "10px 0",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ color: "#333", marginBottom: "10px" }}>
                Question {item.questionIndex + 1}: {item.questionText}
              </h3>

              {item.content_relevance && (
                <div style={{ marginBottom: "8px" }}>
                  <strong>Relevance Score: </strong>
                  <span
                    style={{
                      color: item.content_relevance > 0.7 ? "green" : "orange",
                    }}
                  >
                    {item.content_relevance}
                  </span>
                </div>
              )}

              {item.relevance_feedback && (
                <div>
                  <strong>Feedback: </strong>
                  <span>{item.relevance_feedback}</span>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="space-y-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Take Assessment Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="p-6 max-w-4xl mx-auto mt-8 shadow-lg rounded-lg bg-white relative">
        {showPopup && currentSection && (
          <div className="fixed inset-0 bg-[#000000bd] bg-opacity-50 flex items-center justify-center z-50">
            <div className="m-3 bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h2 className="text-2xl font-bold mb-4 text-gray-800">
                {sectionInfo[currentSection].title}
              </h2>
              <p className="text-gray-600 mb-6">
                {sectionInfo[currentSection].description}
              </p>
              <div className="flex items-start gap-2 bg-yellow-50 border-l-4 border-yellow-500 p-2 rounded-md mb-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-yellow-600 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01M12 5a7 7 0 100 14 7 7 0 000-14z"
                  />
                </svg>
                <p className="text-yellow-800 font-medium mb-0">
                  <strong>Note:</strong> Make sure your recording is at least 3
                  seconds long.
                </p>
              </div>
              <button
                onClick={() => setShowPopup(false)}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                Start Section
              </button>
            </div>
          </div>
        )}

        <div className="mb-6">
          <div className="mb-4">
            <div className="flex flex-col-reverse md:flex-row w-full items-center justify-between md:space-x-4 space-y-2 md:space-y-0 mb-2">
              <h2 className="text-2xl font-bold text-gray-800">
                Speaking Assessment
              </h2>
              <img
                src="/Maxicus_logo.png"
                alt="Maxicus Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            <div className="text-sm text-gray-600 mb-4">
              Question {currentQuestion + 1} of {questions.length}
            </div>
            <div className="question-container bg-white p-4 rounded-lg shadow-sm border border-gray-200">
              {questionAudios[questions[currentQuestion]] ? (
                <>
                  <p className="text-md font-medium text-gray-700 mb-2">
                    {(() => {
                      const currentQuestionData =
                        questionAudios[questions[currentQuestion]];
                      if (!currentQuestionData) return "";

                      switch (currentQuestionData.type) {
                        case "listen_repeat":
                          return "Listen and repeat the same sentence";
                        case "question":
                          return "Play the question and answer in one word";
                        case "join_sentences":
                          return "Listen and repeat the jumbled sentence in correct formation";
                        default:
                          return "Listen to the audio and respond";
                      }
                    })()}
                  </p>

                  <AudioPlayer
                    key={`audio-${currentQuestion}`}
                    src={questionAudios[questions[currentQuestion]].audio}
                    questionText={questions[currentQuestion]}
                    onPlayed={() => {
                      setPlayedQuestions((prev) => ({
                        ...prev,
                        [questions[currentQuestion]]: true,
                      }));
                    }}
                    hasPlayed={
                      playedQuestions[questions[currentQuestion]] || false
                    }
                    onAudioPlay={() => setAudioPlaying(true)}
                    onAudioEnd={() => setAudioPlaying(false)}
                  />
                </>
              ) : (
                <div>
                  {currentQuestion < 2 && (
                    <p className="text-md font-medium text-gray-700 mb-2">
                      Read carefully and repeat it
                    </p>
                  )}
                  <p className="text-lg text-gray-800">
                    {questions[currentQuestion]}
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{
                width: `${((currentQuestion + 1) / questions.length) * 100}%`,
              }}
            ></div>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex gap-4 mb-4 flex-col md:flex-row">
            {!recording ? (
              <button
                onClick={startRecording}
                disabled={
                  hasRecorded[currentQuestion] ||
                  recording ||
                  audioPlaying ||
                  !playedQuestions[questions[currentQuestion]]
                }
                className={`px-6 py-3 rounded-lg font-medium flex items-center gap-2 ${
                  hasRecorded[currentQuestion] ||
                  recording ||
                  audioPlaying ||
                  !playedQuestions[questions[currentQuestion]]
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700 text-white"
                }`}
              >
                <div className="w-4 h-4 bg-white rounded-full"></div>
                {audioPlaying
                  ? "Wait for audio to finish"
                  : hasRecorded[currentQuestion]
                  ? "Recorded"
                  : playedQuestions[questions[currentQuestion]]
                  ? "Start Recording"
                  : "Listen to the question first"}
              </button>
            ) : (
              <button
                disabled={timeLeft > 56}
                onClick={stopRecording}
                className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center gap-2"
              >
                <div className="w-4 h-4 bg-white"></div>
                Stop Recording
              </button>
            )}

            {recording && (
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 text-red-600">
                  <div className="w-3 h-3 bg-red-600 rounded-full animate-pulse"></div>
                  <span className="font-medium">Recording...</span>
                </div>
                <div className="flex items-center gap-2">
                  <div
                    className={`px-3 py-1 rounded-full text-sm font-bold ${
                      timeLeft <= 10
                        ? "bg-red-100 text-red-700"
                        : timeLeft <= 30
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-green-100 text-green-700"
                    }`}
                  >
                    {formatTime(timeLeft)}
                  </div>
                </div>
              </div>
            )}
          </div>

          {(currentRecording || recordings[currentQuestion]) && (
            <div className="mb-4">
              <audio
                controls
                controlsList="nodownload"
                src={URL.createObjectURL(
                  currentRecording || recordings[currentQuestion]
                )}
                className="w-full"
              />
            </div>
          )}

          {hasRecordingForCurrentQuestion && (
            <p className="text-green-600 text-sm flex items-center gap-1">
              <span className="w-2 h-2 bg-green-600 rounded-full"></span>
              Recording saved for this question
            </p>
          )}
        </div>

        <div className="flex justify-between items-center">
          {!isLastQuestion ? (
            <button
              onClick={goToNextQuestion}
              disabled={
                (!recordings[currentQuestion] && !currentRecording) || recording
              }
              className={`px-6 py-2 rounded-lg font-medium ${
                (!recordings[currentQuestion] && !currentRecording) || recording
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
              }`}
            >
              Next
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              disabled={
                !allQuestionsAnswered || loading || recording || testSubmitted
              }
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                allQuestionsAnswered
                  ? "bg-green-600 text-white hover:bg-green-700"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              } ${loading ? "opacity-70" : ""}`}
              title={
                !allQuestionsAnswered
                  ? "Please answer all questions before submitting"
                  : ""
              }
            >
              {loading ? (
                <span className="flex items-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                <>{testSubmitted ? "Assessment Submitted" : "Submit Assessment"}</>
              )}
            </button>
          )}
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <h4 className="text-lg font-semibold mb-3 text-gray-700">
            Questions Overview
          </h4>
          <div className="flex gap-2 flex-wrap">
            {questions.map((question, index) => (
              <div key={index} className="flex items-center gap-2 text-sm">
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                    index === currentQuestion
                      ? "bg-blue-600 text-white"
                      : recordings[index]
                      ? "bg-green-600 text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  {index + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SpeakingAssessment;
